import Icons from './categories/icons'
import Files from './categories/files'
import Genres from './categories/gender'
import Documents from './categories/documents'

type CategoryList = 'Icon' | 'File' | 'Document' | 'Gender'

type AvailableCategorys = {
  [key: string]: any
}

export default function getAssets(category: CategoryList, name?: string) {
  const availableAssets: AvailableCategorys = {
    Icon: Icons,
    File: Files || 'blank',
    Gender: Genres,
    Document: Documents,
  }

  const selectedCategory = availableAssets[category]

  return selectedCategory[name || '']
}
